import styled from 'styled-components';
import { colors, wrapper } from 'globalStyles';

export const Wrapper = styled.div`
  .analytics-page__content {
    ${wrapper}
    height: 100%;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: ${colors.MEDIUM_GRAY};
    margin: 0px auto;
    
    .DateRangePicker__picker {
      z-index: 1000;
      .CalendarMonth__caption {
        padding: 15px 0 50px !important;
      }
    }
  }
`;

export const IframeWrapper = styled.div`
  padding-bottom: 3em;
  .iframe-container {
    margin-top: 40px;
    width: 100%;
    height: 100vh;

    > iframe {
      border: 0;
      display: none;
      &.show {
        display: block;
      }
    }
   
  }
`;

export const Title = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.ul`
  &.cancel {
    color: ${colors.MAIN_COLOR};
    cursor: pointer;
    font-size: 12px;
    font-family: poppins, sans-serif;
    font-weight: bold;
    line-height: 19px;
    margin-right: 20px;
    text-decoration: underline;
  }
`;


// WEBPACK FOOTER //
// ./src/containers/AnalyticsPage/styledComponents.js